// export const Field1Type = {
//     TITLE:                  'title',
//     PRIORITY:               'priority',
//     SCHEDULE:               'schedule',
//     DEADLINE:               'deadline',
//     TASK_TYPE:              'task-type',
//     DATE_CREATED:           'date-created',
//     DATE_CLOSED:            'date-closed',
//     LAST_UPDATED:           'last-updated',
//
//     COVER                   : 'cover',
//
//     // status fields
//     STATUS:                 'status',
//     SYSTEM_STATUS:          'system_status',
//
//     //
//     TASK_ID:                'task-id',
//     PARENT_TASK_ID:         'parent-task-id',
//     USERS:                  'users',
//     TAGS:                   'tags',
//     ESTIMATE:               'estimate',
//     ESTIMATE_MINUTES:       'estimate_minutes',
//     ESTIMATE_HOURS:         'estimate_hours',
//     PROGRESS_BAR:           'progress-bar',         // manual progress ?
//     PROGRESS_ITEMS:         'progress-items',       // based on subitem (children)
//
//     // Ok... pohoze chto eto Field kot. schitaet progress v % based on number of tasks (!)
//     // progressTasks ... po hodu eto tol'ko dlya proektov nado ???
//     PROGRESS_PROJECT_TASKS:          'progress-auto',
//
//     TIME_REPORTED:          'time-reported',
//     TIME_REPORTED_MINUTES:  'time-reported_minutes',
//     TIME_REPORTED_HOURS:    'time-reported_hours',
//     CREATED_BY:             'created-by',
//     ACTION_REQUIRED:        'action-required',
//     ASSIGNED_TO:            'assigned-to',
//
//     START_DATE:             'start-date',
//     END_DATE:               'end-date',
//     START_END_DATE:         'start-end',
//     //
//     CUSTOM_FIELD:           'custom-field',
//
//     PROJECT:                'project',
//     PROJECT_TYPE:           'project-type',
//     PROJECT_FULL_NAME:      'project-full-name',
//     SUBTASKS_COUNTER:       'subtasks-counter',
//     DURATION_CALENDAR_DAYS: 'duration-calendar-days',
//     DURATION_WORK_DAYS:     'duration-work-days',
//     SPENT_ESTIMATE:         'spent-estimate',
//     DEPENDS_ON:             'depends-on',
//     DEPENDANTS:             'dependants',
//     STORY_POINTS:           'story-points',
//     MESSAGES_TOTAL:         'messages-total',   // total number of meesages in a task
//     ATTACHMENTS_TOTAL:      'attachments-total',
//
//     // FINANCE SECTION
//     COST_INTERNAL:          'cost-internal',    // time reports * rate
//     COST_EXTERNAL:          'cost-external',    // time reports * rate
//     COST_EXPENSES:          'expenses',
//
//     //projects only
//     COMMENTS:               'comments',
//     OPEN_ALL:               'open-all',
//     OWNER:                  'owner',
//     PROJECT_MANAGER:        'project-manager',
//     PROJECT_COLOR:          'project-color',
//     PROJECT_HEALTH:         'project-health',
//     PROJECT_STATUS_COMMENTS:'project-status-comments',
//
//     DESCRIPTION:            'description',      // used with task in import at least and export
//
//     //gantt only
//     BASELINE:               'baseline',
//
//     //not actual field
//     CHECK_BOX:              'check-box',
//
//
//
//     // FIELDS2 MOVED TO  src/core/model2/project/project-fields.js
//     // pravil'no uzat' FIELDS.STRING
//     // tut chto bi ne lomalos' prosto (!)
//     // SUDA NE DOBAVLYAT BOLSHE !!!!
//
//     // Field 2.0
//     STRING:                 'string',
//     TEXT:                   'textarea',
//     DROPDOWN:               'dropdown',
//     MULTISELECT:            'multiselect',
//     COLOR:                  'color',
//     USER:                   'user',
//     PHONE:                  'phone',
//     EMAIL:                  'email',
//     URL:                    'url',
//     CHECKBOX:               'checkbox',
//     NUMBER:                 'number',
//     CURRENCY:               'currency',
//     PERCENTAGE:             'percentage',
//     DATE:                   'date',
//     RATING:                 'rating',
//     RAG:                    'rag',
//
//     // More System Fields 2.0
//     CRM_CONTACT:            'crm-contact',
//     CRM_CONTACTS:           'crm-contacts',
//     CRM_ACCOUNT:            'crm-account',
//     CRM_CONTACT_TYPE:       'crm-contact-type',
//     CRM_CONTACTS_TOTAL:     'crm-contacts-total',
//     // PROJECT_STATUS:         'project-status'
//
//     // pseudo-field for board
//     TODO_LIST               : 'todo-list',
//
//     LOCATION                : 'location',
// }

export enum Field1Type {
    TITLE =                  'title',
    PRIORITY =               'priority',
    SCHEDULE =               'schedule',
    DEADLINE =               'deadline',
    TASK_TYPE =              'task-type',
    DATE_CREATED =           'date-created',
    DATE_CLOSED =            'date-closed',
    LAST_UPDATED =           'last-updated',

    COVER                    = 'cover',

    // status fields
    STATUS =                 'status',
    SYSTEM_STATUS =          'system_status',

    //
    TASK_ID =                'task-id',
    PARENT_TASK_ID =         'parent-task-id',
    USERS =                  'users',
    TAGS =                   'tags',
    ESTIMATE =               'estimate',
    ESTIMATE_MINUTES =       'estimate_minutes',
    ESTIMATE_HOURS =         'estimate_hours',
    PROGRESS_BAR =           'progress-bar',         // manual progress ?
    PROGRESS_ITEMS =         'progress-items',       // based on subitem (children)

    // Ok... pohoze chto eto Field kot. schitaet progress v % based on number of tasks (!)
    // progressTasks ... po hodu eto tol'ko dlya proektov nado ???
    PROGRESS_PROJECT_TASKS =          'progress-auto',

    TIME_REPORTED =          'time-reported',
    TIME_REPORTED_MINUTES =  'time-reported_minutes',
    TIME_REPORTED_HOURS =    'time-reported_hours',
    CREATED_BY =             'created-by',
    ACTION_REQUIRED =        'action-required',
    ASSIGNED_TO =            'assigned-to',

    START_DATE =             'start-date',
    END_DATE =               'end-date',
    START_END_DATE =         'start-end',
    //
    CUSTOM_FIELD =           'custom-field',

    PROJECT =                'project',
    PROJECT_TYPE =           'project-type',
    PROJECT_FULL_NAME =      'project-full-name',
    SUBTASKS_COUNTER =       'subtasks-counter',
    DURATION_CALENDAR_DAYS = 'duration-calendar-days',
    DURATION_WORK_DAYS =     'duration-work-days',
    SPENT_ESTIMATE =         'spent-estimate',
    DEPENDS_ON =             'depends-on',
    DEPENDANTS =             'dependants',
    STORY_POINTS =           'story-points',
    MESSAGES_TOTAL =         'messages-total',   // total number of meesages in a task
    ATTACHMENTS_TOTAL =      'attachments-total',

    // FINANCE SECTION
    COST_INTERNAL =          'cost-internal',    // time reports * rate
    COST_EXTERNAL =          'cost-external',    // time reports * rate
    COST_EXPENSES =          'expenses',

    //projects only
    COMMENTS =               'comments',
    OPEN_ALL =               'open-all',
    OWNER =                  'owner',
    PROJECT_MANAGER =        'project-manager',
    PROJECT_COLOR =          'project-color',
    PROJECT_HEALTH =         'project-health',
    PROJECT_STATUS_COMMENTS ='project-status-comments',

    DESCRIPTION =            'description',      // used with task in import at least and export

    //gantt only
    BASELINE =               'baseline',

    //not actual field
    CHECK_BOX =              'check-box',
    ADD_CELL =               'add-cell',

    ESTIMATED_COST_INTERNAL = 'estimated-cost-internal',
    ESTIMATED_COST_EXTERNAL = 'estimated-cost-external',

    // FIELDS2 MOVED TO  src/core/model2/project/project-fields.js
    // pravil'no uzat' FIELDS.STRING
    // tut chto bi ne lomalos' prosto (!)
    // SUDA NE DOBAVLYAT BOLSHE !!!!

    // Field 2.0
    STRING =                 'string',
    TEXT =                   'textarea',
    DROPDOWN =               'dropdown',
    MULTISELECT =            'multiselect',
    COLOR =                  'color',
    USER =                   'user',
    PHONE =                  'phone',
    EMAIL =                  'email',
    URL =                    'url',
    CHECKBOX =               'checkbox',
    NUMBER =                 'number',
    CURRENCY =               'currency',
    PERCENTAGE =             'percentage',
    DATE =                   'date',
    RATING =                 'rating',
    RAG =                    'rag',

    // More System Fields 2.0
    CRM_CONTACT =            'crm-contact',
    CRM_CONTACTS =           'crm-contacts',
    CRM_ACCOUNT =            'crm-account',
    CRM_CONTACT_TYPE =       'crm-contact-type',
    CRM_CONTACTS_TOTAL =     'crm-contacts-total',
    // PROJECT_STATUS =         'project-status'

    // pseudo-field for board
    TODO_LIST                = 'todo-list',

    LOCATION                 = 'location',
}



export const Field1TitleDict = {
    'title':                    'Title',
    'status':                   'Status',
    'system_status':            'System Status',
    'priority':                 'Priority',
    'schedule':                 'Schedule',
    'deadline':                 'Deadline',
    'task-type':                'Type',
    'assigned-to':              'Assigned to',
    'date-created':             'Date created',
    'date-closed':              'Date closed',
    'last-updated':             'Last updated',
    'task-id':                  'ID',
    'parent-task-id':           'Parent Task ID',
    'users':                    'All users',
    'tags':                     'Tags',
    'estimate':                 'Estimate',
    'estimate_minutes':         'Estimate (Minutes)',
    'estimate_hours':           'Estimate (Hours)',
    'progress-bar':             'Progress, %',
    'progress-items':           'Progress, items',
    'progress-auto':            'Progress Tasks',
    'time-reported':            'Time reported',
    'time-reported_minutes':    'Time reported (Minutes)',
    'time-reported_hours':      'Time reported (Hours)',
    'created-by':               'Created by',
    'action-required':          'Action required',
    'start-date':               'Start date',
    'end-date':                 'End date',
    'start-end':                'Start / End',
    'duration-calendar-days':   'Duration',
    'duration-work-days':       'Duration workdays',
    'spent-estimate':           'Spent / Estimate',
    'depends-on':               'Depends On',
    'dependants':               'Dependants',

    'project':                  'Project',
    'project-full-name':        'Project Path',
    'project-status-comments':  'Project status comments',

    'subtasks-counter':         'Subtasks',

    'comments':                 'Comments',
    'open-all':                 'Open tasks',
    'owner':                    'Project owner',
    'project-manager':          'Project manager',
    'project-color':            'Color',
    'project-health':           'Health',

    'description':              'Description',

    'cost-internal':            'Labor cost',
    'cost-external':            'Service cost',
    'expenses':                 'Expenses',

    'story-points':             'Story points',
    'messages-total':           'Messages',
    'attachments-total':        'Attachments',

    'baseline':                 'Baseline',
};



// no idea why we have 2 dicts...
// label in fields list (settings/popover)
export const Field1LabelDict : DictionaryStringString = {
    'title':                    'Title',
    'status':                   'Status',
    'system_status':            'System Status',
    'priority':                 'Priority',
    'schedule':                 'Schedule',
    'deadline':                 'Deadline',
    'task-type':                'Type',
    'assigned-to':              'Assigned to',
    'date-created':             'Date created',
    'date-closed':              'Date closed',
    'last-updated':             'Last updated',
    'task-id':                  'ID',
    'parent-task-id':           'Parent Task ID',
    'users':                    'All users',
    'tags':                     'Tags',
    'estimate':                 'Estimate',
    'estimate_minutes':         'Estimate (Minutes)',
    'estimate_hours':           'Estimate (Hours)',
    'progress-bar':             'Progress, %',
    'progress-items':           'Progress, items',
    'progress-auto':            'Progress Tasks',
    'time-reported':            'Time reported',
    'time-reported_minutes':    'Time reported (Minutes)',
    'time-reported_hours':      'Time reported (Hours)',
    'created-by':               'Created by',
    'action-required':          'Action required',
    'start-date':               'Start date',
    'end-date':                 'End date',
    'start-end':                'Start / End',
    'duration-calendar-days':   'Duration calendar days',
    'duration-work-days':       'Duration work days',
    'spent-estimate':           'Spent / Estimate',
    'depends-on':               'Depends On',
    'dependants':               'Dependants',

    'project':                  'Project',
    'project-full-name':        'Project Path',
    'project-status-comments':  'Project status comments',

    'subtasks-counter':         'Subtasks',

    'comments':                 'Comments',
    'open-all':                 'Open tasks',
    'owner':                    'Project owner',
    'project-manager':          'Project manager',
    'project-color':            'Color',
    'project-health':           'Health',

    'description':              'Description',

    'cost-internal':            'Labor cost',
    'cost-external':            'Service cost',
    'expenses':                 'Expenses',

    'story-points':             'Story points',
    'messages-total':           'Messages',
    'attachments-total':        'Attachments',

    'crm-account':              'CRM Company',
    'crm-contacts':             'CRM Contacts',

    'baseline':                 'Baseline',
};